import React from "react";
import "../styles/Global.css";
import "../styles/App.css";
import AuthenticatedApp from "./AuthenticatedApp";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsalAuthentication,
} from "@azure/msal-react";
import UnAuthenticatedApp from "./UnAuthenticatedApp";

const App = () => {
  const { login, result, error } = useMsalAuthentication("popup");

  return (
    <div className="container">
      <AuthenticatedTemplate>
        <AuthenticatedApp />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UnAuthenticatedApp />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default App;
